// extracted by mini-css-extract-plugin
export var sliderRange = "_cj-2";
export var sliderRoot = "_cj-0";
export var sliderThumb = "_cj-3";
export var sliderTrack = "_cj-1";